import React, { useState, useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import NavigationBarConsumer from "../components/common/NavigationBarConsumer/NavigationBarConsumer";
import { cn } from "../Utils/helper";

const Main = () => {
  const location = useLocation();
  const footerRef = useRef(null);
  const [footerHeight, setFooterHeight] = useState(0);

  const screensHideFooter = [
    "/sign-in",
    "/register",
    "/verify-otp",
    "/preview",
    "/forgot-password",
    "/reset-password",
    "/search-company",
    "/profile-company",
    "/qr-code",
    "/ondemand",
    "/ondemand/add-objective",
    "/result",
  ];

  // Check if footer should be hidden (including nested routes)
  const shouldHideFooter = screensHideFooter.some(
    (path) => location.pathname === path || location.pathname.startsWith(path)
  );

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Update footer height dynamically
  useEffect(() => {
    if (shouldHideFooter) {
      setFooterHeight(0);
      return; // Skip height calculation if footer is hidden
    }

    const updateFooterHeight = () => {
      setFooterHeight(footerRef.current?.offsetHeight || 0);
    };

    updateFooterHeight();
    window.addEventListener("resize", updateFooterHeight);

    const observer = new ResizeObserver(updateFooterHeight);
    const footerElement = footerRef.current;
    if (footerElement) {
      observer.observe(footerElement);
    }

    return () => {
      window.removeEventListener("resize", updateFooterHeight);
      if (footerElement) {
        observer.unobserve(footerElement);
      }
    };
  }, [shouldHideFooter]);

  return (
    <div className="flex flex-col justify-center min-h-screen w-full max-w-[480px] mx-auto">
      <div
        className={cn("flex-1")}
        style={{ paddingBottom: shouldHideFooter ? 0 : `${footerHeight}px` }}
      >
        <Outlet />
      </div>
      {!shouldHideFooter && (
        <footer
          ref={footerRef}
          className="fixed bottom-0 left-0 right-0 w-full bg-white shadow-md z-10 items-center flex justify-center"
          role="navigation"
          aria-label="Main navigation footer"
        >
          <NavigationBarConsumer />
        </footer>
      )}
    </div>
  );
};

export default Main;
